import gql from 'graphql-tag';
import { apollo } from 'src/features';
import i18n from 'src/features/i18n';

const mutation = gql`
mutation ActivityCreateByRequestType($requestTypeId: Int!, $channelIdentifier: String!) {
  activityByRequestType(requestTypeId: $requestTypeId, channelIdentifier: $channelIdentifier) {
    id
  }
}`;

function createActivityByRequestType(requestTypeId, channelIdentifier) {
  return apollo.client.mutate({
    mutation,
    variables: {
      requestTypeId: parseInt(requestTypeId, 10),
      channelIdentifier,
    },
  }).then((res) => (res.data.activityByRequestType.id))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default createActivityByRequestType;
